'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _helpers = require('./helpers');

var _helpers2 = _interopRequireDefault(_helpers);

var _responsives = require('./responsives');

var _responsives2 = _interopRequireDefault(_responsives);

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

var _typography = require('./typography');

var _typography2 = _interopRequireDefault(_typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compose = function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (args) {
    return fns.reduce(function (arg, fn) {
      return fn(arg);
    }, args);
  };
};

exports.default = {
  propTypes: _extends({}, _helpers2.default.propTypes, _responsives2.default.propTypes, _colors2.default.propTypes, _typography2.default.propTypes),
  defaultProps: _extends({}, _helpers2.default.defaultProps, _responsives2.default.defaultProps, _colors2.default.defaultProps, _typography2.default.defaultProps),
  classnames: function classnames(props) {
    return (0, _classnames3.default)(_helpers2.default.classnames(props), _responsives2.default.classnames(props), _colors2.default.classnames(props), _typography2.default.classnames(props));
  },
  clean: function clean(props) {
    return compose(_helpers2.default.clean, _responsives2.default.clean, _colors2.default.clean, _typography2.default.clean)(props);
  }
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bulma-components/lib/modifiers/index.js
// module id = 39
// module chunks = 0